// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/authorization/v1/role_binding_api.proto (package ai.h2o.authorization.v1, syntax proto3)
/* eslint-disable */

import type { RoleBinding } from "./role_binding_pb";
import { RPC } from "../../../../runtime";

/**
 * @generated from message ai.h2o.authorization.v1.GetRoleBindingRequest
 */
export type GetRoleBindingRequest = {
/**
 * RoleBinding name, e.g. "roleBindings/<UUID>".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.GetRoleBindingResponse
 */
export type GetRoleBindingResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.RoleBinding role_binding = 1;
 */
roleBinding?: RoleBinding;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreateRoleBindingRequest
 */
export type CreateRoleBindingRequest = {
/**
 * @generated from field: ai.h2o.authorization.v1.RoleBinding role_binding = 1;
 */
roleBinding?: RoleBinding;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreateRoleBindingResponse
 */
export type CreateRoleBindingResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.RoleBinding role_binding = 1;
 */
roleBinding?: RoleBinding;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.UpdateRoleBindingRequest
 */
export type UpdateRoleBindingRequest = {
/**
 * @generated from field: ai.h2o.authorization.v1.RoleBinding role_binding = 1;
 */
roleBinding?: RoleBinding;
/**
 * Only the fields specified in update_mask will be updated.
 *
 * Supported fields:
 *   - role
 *   - subject
 *   - annotations or annotations.<key>
 *
 * Only supported fields are updated when the mask is empty or "*".
 *
 * When 'annotations' field is specified all of the annotations are
 * replaced with the new set. When 'annotations.<key>' is specified only
 * the specified annotation is updated or removed if the value is empty.
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.UpdateRoleBindingResponse
 */
export type UpdateRoleBindingResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.RoleBinding role_binding = 1;
 */
roleBinding?: RoleBinding;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeleteRoleBindingRequest
 */
export type DeleteRoleBindingRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeleteRoleBindingResponse
 */
export type DeleteRoleBindingResponse = {
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListRoleBindingsRequest
 */
export type ListRoleBindingsRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return more or less items then specified.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * When used, server will only return role bindings that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 * See https://github.com/h2oai/authz-server/blob/main/docs/adopting.md#filtering for specific supported
 * features.
 *
 * Supported fields:
 *   * resource
 *   * subject
 *   * annotations
 *   * role
 *
 *
 * @generated from field: string filter = 3;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListRoleBindingsResponse
 */
export type ListRoleBindingsResponse = {
/**
 * @generated from field: repeated ai.h2o.authorization.v1.RoleBinding role_bindings = 1;
 */
roleBindings?: RoleBinding[];
/**
 * When not empty server has more results then returned. Use this value as
 * the page_token in the ListRoleBindingsRequest to obtain next page of
 * results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.BatchCreateRoleBindingsRequest
 */
export type BatchCreateRoleBindingsRequest = {
/**
 * @generated from field: repeated ai.h2o.authorization.v1.CreateRoleBindingRequest requests = 1;
 */
requests?: CreateRoleBindingRequest[];
}
;
/**
 * @generated from message ai.h2o.authorization.v1.BatchCreateRoleBindingsResponse
 */
export type BatchCreateRoleBindingsResponse = {
/**
 * Role bindings that were created.
 *
 * @generated from field: repeated ai.h2o.authorization.v1.RoleBinding role_bindings = 1;
 */
roleBindings?: RoleBinding[];
}
;
/**
 * @generated from message ai.h2o.authorization.v1.BatchDeleteRoleBindingsRequest
 */
export type BatchDeleteRoleBindingsRequest = {
/**
 * Names of the role bindings to delete.
 *
 * @generated from field: repeated string names = 1;
 */
names?: string[];
/**
 * When true, missing role bindings are ignored and not reported as errors.
 * When allow_missing is false (the default), missing role bindings will
 * cause an error and no role bindings will be deleted.
 *
 * @generated from field: bool allow_missing = 2;
 */
allowMissing?: boolean;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.BatchDeleteRoleBindingsResponse
 */
export type BatchDeleteRoleBindingsResponse = {
/**
 * IDs of the role bindings that were deleted.
 *
 * @generated from field: repeated string ids = 1;
 */
ids?: string[];
}
;
/**
 * Returns details of the role binding specified by the name.
 *
 * Authorized by the "actions/policyserver/roleBindings/READ" action on the
 * the resource the binding is bound to.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.GetRoleBinding
 */
export const RoleBindingService_GetRoleBinding = new RPC<GetRoleBindingRequest,GetRoleBindingResponse>("GET", "/v1/{name=roleBindings/*}");
/**
 * Creates a new role binding.
 *
 * Authorization is checked on the resource the binding is about to be bound to
 * against the "actions/policyserver/roleBindings/CREATE" action that requires
 * "role=<role>" context match to the role of the binding.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.CreateRoleBinding
 */
export const RoleBindingService_CreateRoleBinding = new RPC<CreateRoleBindingRequest,CreateRoleBindingResponse>("POST", "/v1/roleBindings", "roleBinding");
/**
 * Updates the role binding specified by the name.
 *
 * Authorized by the "actions/policyserver/roleBindings/UPDATE" action on the
 * the resource the binding is bound to.
 *
 * When the resource is updated, the authorization is checked against the
 * "actions/policyserver/roleBindings/UPDATE" action that requires
 * "role=<role>" context match to the role of the binding.
 *
 * When the role is updated, the authorization is checked against the
 * "actions/policyserver/roles/CREATE" that requires "role=<role>" context
 * matching the new role and the "actions/policyserver/roleBindings/DELETE"
 * action that requires "role=<role>" context match to the (old) role of
 * the binding.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.UpdateRoleBinding
 */
export const RoleBindingService_UpdateRoleBinding = new RPC<UpdateRoleBindingRequest,UpdateRoleBindingResponse>("PATCH", "/v1/{roleBinding.name=roleBindings/*}", "roleBinding");
/**
 * Deletes the role binding specified by the name.
 *
 * Authorization is checked on the resource the binding is bound to against the
 * "actions/policyserver/roleBindings/DELETE" action that requires
 * "role=<role>" context match to the role of the binding.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.DeleteRoleBinding
 */
export const RoleBindingService_DeleteRoleBinding = new RPC<DeleteRoleBindingRequest,DeleteRoleBindingResponse>("DELETE", "/v1/{name=roleBindings/*}");
/**
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.ListRoleBindings
 */
export const RoleBindingService_ListRoleBindings = new RPC<ListRoleBindingsRequest,ListRoleBindingsResponse>("GET", "/v1/roleBindings");
/**
 * Creates a batch of role bindings. Operation is atomic.
 * Either all role bindings are created or none.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.BatchCreateRoleBindings
 */
export const RoleBindingService_BatchCreateRoleBindings = new RPC<BatchCreateRoleBindingsRequest,BatchCreateRoleBindingsResponse>("POST", "/v1/roleBindings:batchCreate");
/**
 * Operation deletes a batch of role bindings. Operation is atomic.
 * Either all role bindings are deleted or none.
 *
 * @generated from rpc ai.h2o.authorization.v1.RoleBindingService.BatchDeleteRoleBindings
 */
export const RoleBindingService_BatchDeleteRoleBindings = new RPC<BatchDeleteRoleBindingsRequest,BatchDeleteRoleBindingsResponse>("POST", "/v1/roleBindings:batchDelete");
